// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__ZHOXq","itemTitle":"ClientEmergencyInfo_itemTitle__2gzfD","itemText":"ClientEmergencyInfo_itemText__ycF1t"};